/**
 * Colors from the Figma design
 */
const WORKFORCE_COLORS = {
  base: {
    10: '#FFFFFF',
    20: '#F0F1F2',
    25: '#FAF1BA',
    30: '#FFD600',
    32: '#EDBD00',
    34: '#B18F00',
    40: '#181616',
    45: '#979CA4',
    46: '#546175',
    50: '#3D4551',
    60: '#26323F',
    70: '#141B22',
    80: '#000000',
  },
}

export default WORKFORCE_COLORS
